import { Validator } from 'vee-validate';
import Vue from 'vue';
import apiClient from '../apiClient';

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

const Validators = {};

Validators.register = function register(VeeValidate) {
  console.log('Loading custom validators');

  VeeValidate.Validator.extend('customer_unique_email', {
    // getMessage: 'Esite già un cliente con l\'indirizzo email specificato.',
    getMessage(field) {
      return `Esite già un cliente con l'indirizzo email ${field}.`;
    },
    validate: async (value) => {
      try {
        await apiClient.calls(Vue).checkCustomer('email', value);
        return { valid: true };
      } catch (e) {
        return { valid: false };
      }
    },
  });

  VeeValidate.Validator.extend('customer_unique_piva', {
    getMessage(field) {
      return `Esite già un cliente con lo stesso codice fiscale o partita iva.`;
    },
    validate: async (value) => {
      try {
        await apiClient.calls(Vue).checkCustomer('piva_cfisc', value);
        return { valid: true };
      } catch (e) {
        return { valid: false };
      }
    },
  });

  VeeValidate.Validator.extend('user_unique_email', {
    // messages: {
    //   en: (field, args) => 'A user with the same email address already exists.',
    //   it: (field, args) => 'Esite già un utente con l\'indirizzo email specificato.',
    // },
    getMessage(field) {
      return 'Esite già un utente con l\'indirizzo email specificato.';
    },
    validate: async (value) => {
      try {
        await apiClient.calls(Vue).checkUser('email', value);
        return { valid: true };
      } catch (e) {
        return { valid: false };
      }
    },
  });

  VeeValidate.Validator.extend('user_unique_phone_number', {
    getMessage(field) {
      return 'Esite già un utente con il numero telefonico specificato.';
    },
    validate: async (value) => {
      try {
        await apiClient.calls(Vue).checkUser('phone_number', value);
        return { valid: true };
      } catch (e) {
        return { valid: false };
      }
    },
  });

  VeeValidate.Validator.extend('piva_cfisc', {
    getMessage(field) {
      return 'Inserisci un codice fiscale o una partita iva valide.';
    },
    validate: async (value) => {
      const pattern = /^((?:[B-DF-HJ-NP-TV-Z](?:[AEIOU]{2}|[AEIOU]X)|[AEIOU]{2}X|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[\dLMNP-V][1-9MNP-V]|[1-9MNP-V][0L]))[A-Z])|([0-9]{11})$/i;
      const valid = value.search(pattern) > -1;
      return { valid };
    },
  });

  VeeValidate.Validator.extend('phone_number', {
    getMessage(field) {
      return 'Numero di telefono non valido';
    },
    validate: (value) => {
      const phone = phoneUtil.parse(value);
      return { valid: phoneUtil.isValidNumber(phone) };
    },
  });

  VeeValidate.Validator.extend('ip_subnet_block', {
    getMessage(field) {
      return 'E\' stato inserito un IP o una sottorete non valida.';
    },
    validate: async (values) => {
      const regexIp = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g;
      const regexCidr = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([0-9]|[1-2][0-9]|3[0-2]))$/g;

      const addresses = values.split('\n');
      let valid = true;

      for (let i = 0; i < addresses.length; i++) {
        addresses[i] = addresses[i].trim();

        if (addresses[i].indexOf('/') >= 0) { valid = addresses[i].search(regexCidr) > -1; } else if (addresses[i] !== '') { valid = addresses[i].search(regexIp) > -1; }

        if (!valid) break;
      }
      return { valid };
    },
  });

  VeeValidate.Validator.extend('verify_password', {
    getMessage: field => 'La password deve contenere almeno: 1 maiuscola, 1 minuscola, 1 numero ed un carattere speciale. (ad esempio: , . _ & ? ecc..)',
    validate: (value) => {
      const strongRegex = new RegExp('^.*(?=.{8,})((?=.*[!?@#$%^&*()\\-_=+{};:,<.>]){1})(?=.*\\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$');
      return strongRegex.test(value);
    },
  });
};


const userValidator = new Validator({
  email: 'email|user_unique_email',
  phone_number: 'phone_number|user_unique_phone_number',
  first_name: 'alpha_spaces',
  last_name: 'alpha_spaces',
  plan: 'required',
});

export default Validators;
export { userValidator };



// WEBPACK FOOTER //
// ./src/plugins/validators.js